<template>
  <div class="settings-section w-100 bs-bb">
    <div class="accordion-card" :class="{ open: isOpen }">
      <div class="accordion-header d-f ai-c jc-sb pointer" @click="isOpen = !isOpen">
        <div class="d-f ai-c g">
          <slot name="icon" />
          <p class="m-0">{{ title }}</p>
        </div>
        <div class="d-f ai-c g">
          <span v-if="status" class="mute">{{ status }}</span>
          <IconBase class="chevron" :class="{ 'rotate-180': isOpen }" :w="15" :h="15">
            <IconChevronDown />
          </IconBase>
        </div>
      </div>
      <div v-show="isOpen" class="accordion-body">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import IconBase from "@/assets/icons/IconBase.vue";
import IconChevronDown from "@/assets/icons/IconChevronDown.vue";

export default {
  name: "SettingsSection",
  components: { IconBase, IconChevronDown },
  props: {
    title: { type: String, required: true },
    status: { type: String, default: null },
  },
  data() {
    return { isOpen: false };
  },
};
</script>

<style lang="scss" scoped>
@import "@/scss/_variables.scss";
@import "@/scss/_classes.scss";

.accordion-card {
  width: 100%;
  box-sizing: border-box;
  border: $border-small solid $line-color;
  border-radius: $border-radius-input;

  &:not(.open):hover {
    border-color: $brand-hl;
  }
}

.accordion-header {
  height: $btn-height;
  min-height: $btn-height;
  padding: 0 $mg-desktop-md;
  user-select: none;
  box-sizing: border-box;
  border-bottom: $border-small solid transparent;
  transition: border-color 0.15s ease;

  .open & {
    border-bottom-color: $line-color;
  }
}

.accordion-body {
  padding: $mg-desktop-md;
  display: flex;
  flex-direction: column;
  gap: $mg-desktop;
}

.chevron {
  flex-shrink: 0;
  transition: transform 0.2s ease;

  &.rotate-180 {
    transform: rotate(180deg);
  }
}
</style>
